jQuery(function () {
ContentSlide();
function ContentSlide() {
    var slideHeight = 175;
    const contentHeightOne = 991;
    const contentHeightTwo = 100;
    const contentHeightThree = 90;

    var mobcontentSlideThree;
    if (window.matchMedia('(max-width: 576px)').matches) {
        mobcontentSlideThree = 207;
        slideHeight = 295;
    }
    else if (window.matchMedia('(max-width: 1118px)').matches) {
        mobcontentSlideThree = 105;
    }

    const contentHeightFour = 44;
    if (window.matchMedia('(max-width: 1118px)').matches) {
        if ($(".MobContentSlide").hasClass("ContentSlide--ProductDetails")) {
            if ($(window).width() > contentHeightOne) {
                var contentHeightDynamic = contentHeightTwo;
            } else {
                var contentHeightDynamic = mobcontentSlideThree;
            }
        }
        else {
            var contentHeightDynamic = contentHeightFour;
        }
    }
    else {
        if ($(".ContentSlide").hasClass("ContentSlide--ProductDetails")) {
            if ($(window).width() > contentHeightOne) {
                var contentHeightDynamic = contentHeightTwo;
            } else {
                var contentHeightDynamic = contentHeightThree;
            }
        }
        else {
            var contentHeightDynamic = contentHeightFour;
        }
    }
    var contentHeight = contentHeightDynamic;
    var minHeight = $(".ContentSlide").height();
    var minMobHeight = $(".MobContentSlide").height();
    if (window.matchMedia('(max-width: 1118px)').matches && $('.MobContentSlide').length) {
        if (minMobHeight <= slideHeight) {
            $(".MobContentSlide").removeClass();
            $(".Button--AccordionWrap").hide();
        } else {
            $('.Button--AccordionWrap').css('display', 'block');
            $('.ContentSlide').css('height', contentHeight + 'px');
            var currentOrientation = window.orientation;
            $(".Button--Accordion").click(function () {
                $(this).toggleClass("show-hide");
                var curHeight = $(".ContentSlide").height();
                var curMobHeight = $(".MobContentSlide").height();
                if (currentOrientation === window.orientation) {
                    if (curMobHeight <= slideHeight) {
                        $(".MobContentSlide").animate({
                            height: minMobHeight
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-less"));
                    } else {
                        $(".MobContentSlide").animate({
                            height: contentHeight
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-more"));
                    }

                } else {
                    $(".MobContentSlide").toggleClass("heightAuto");
                    if ($(".MobContentSlide").hasClass("heightAuto")) {
                        var NewHeight = 0;
                        $(".MobContentSlide").children().each(function () {
                            NewHeight = NewHeight + $(this).outerHeight(true);
                        });
                        $(".MobContentSlide").animate({
                            height: NewHeight
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-less"));
                    } else {
                        $(".MobContentSlide").animate({
                            height: contentHeightDynamic
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-more"));
                    }
                }
            });
        }
    } else {

        if (minHeight <= slideHeight) {
            $(".ContentSlide").removeClass();
            $(".Button--AccordionWrap").hide();
        } else {
            $('.Button--AccordionWrap').css('display', 'block');
            $('.ContentSlide').css('height', contentHeight + 'px');
            var currentOrientation = window.orientation;
            $(".Button--Accordion").click(function () {
                $(this).toggleClass("show-hide");
                var curHeight = $(".ContentSlide").height();
                var curMobHeight = $(".MobContentSlide").height();
                if (currentOrientation === window.orientation) {
                    if (curHeight <= slideHeight) {
                        $(".ContentSlide").animate({
                            height: minHeight
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-less"));
                    } else {
                        $(".ContentSlide").animate({
                            height: contentHeight
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-more"));
                    }
                } else {
                    $(".ContentSlide").toggleClass("heightAuto");
                    if ($(".ContentSlide").hasClass("heightAuto")) {
                        var NewHeight = 0;
                        $(".ContentSlide").children().each(function () {
                            NewHeight = NewHeight + $(this).outerHeight(true);
                        });
                        $(".ContentSlide").animate({
                            height: NewHeight
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-less"));
                    } else {
                        $(".ContentSlide").animate({
                            height: contentHeightDynamic
                        }, "fast");
                        $(this).html($(".Button--Accordion").attr("show-more"));
                    }
                }
            });
        }
    }

}


// mobile view content show more function
var showLessMob = function () {
    $(".ContentSlide").removeClass("heightAuto");
    $(".MobContentSlide").removeClass("heightAuto");
    $(".Button--Accordion").removeClass("show-hide");
    $(".Button--Accordion").html($(".Button--Accordion").attr("show-more"));
    const contentSlideOne = 991;
    const contentSlideTwo = 100;
    const contentSlideThree = 90;
    var mobcontentSlideThree;
    if (window.matchMedia('(max-width: 576px)').matches) {
        mobcontentSlideThree = 207;
    }
    else if (window.matchMedia('(max-width: 1118px)').matches) {
        mobcontentSlideThree = 105;
    }
    const contentSlideFour = 44;
    if ($(".ContentSlide").hasClass("ContentSlide--ProductDetails")) {
        if ($(window).width() > contentSlideOne) {
            contentHeightDynamic = contentSlideTwo;
        } else {
            contentHeightDynamic = mobcontentSlideThree;
        }
    } if ($(".MobContentSlide").hasClass("ContentSlide--ProductDetails")) {
        if ($(window).width() > contentSlideOne) {
            contentHeightDynamic = contentSlideTwo;
        } else {
            contentHeightDynamic = mobcontentSlideThree;
        }
    } else {
        contentHeightDynamic = contentSlideFour;
    }
    $(".ContentSlide").animate({ height: contentHeightDynamic }, "fast");
    $(".MobContentSlide").animate({ height: contentHeightDynamic }, "fast");
}
jQuery(function ($) {
    showLessMob();
})
$(window).on('resize', function () {
    showLessMob();
});
});